// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"a338d709","306":"f83b6f42","326":"af80a04f","453":"fd55c6b2"}[chunkId] + ".chunk.js";
};